import React from 'react';
import SEO from '@/components/common/SEO';
import LandingShell from '@/components/landing/LandingShell';
import {
  DataPolicyDocumentContent,
  legalCompanyAddress,
  legalContactEmail,
  legalLastUpdated,
} from '@/components/legal/LegalDocuments';

export const lastUpdated: string = legalLastUpdated;
export const contactEmail: string = legalContactEmail;
export const companyAddress: string = legalCompanyAddress;

const DataPolicy = () => {
  return (
    <LandingShell>
      <SEO
        title="Data Policy"
        description="Read mapleos data policy, including Canadian data residency, security, retention, and user rights."
        url="/data-policy"
      />
      <div className="container mx-auto max-w-4xl px-4 py-8 md:py-12">
        <h1 className="mb-6 text-3xl font-bold">Data Policy</h1>
        <div className="prose prose-sm dark:prose-invert max-w-none">
          <DataPolicyDocumentContent />
        </div>
      </div>
    </LandingShell>
  );
};

export default DataPolicy;
